import SEO from "@/components/SEO";
import { Reveal, SectionHeading } from "@/components/Reveal";
import { Mail, Phone, ShieldCheck } from "lucide-react";
import { useSite } from "@/context/SiteContext";

const ANPC_SAL_URL = "https://reclamatiisal.anpc.ro/";
const ANPC_SAL_DIRECT_URL = "https://reclamatiisal.anpc.ro/Depune-cerere-SAL";

export default function Reclamatii() {
  const { config } = useSite();
  return (
    <>
      <SEO
        title="Reclamații și soluționarea sesizărilor | BROX CONSTRUCT"
        description="Transmite o reclamație sau o sesizare legată de un proiect, serviciu sau colaborare BROX CONSTRUCT. Telefon, email și soluționare alternativă a litigiilor (SAL — ANPC)."
        path="/reclamatii"
      />
      <section className="grain bg-ink-950 pb-16 pt-32 sm:pt-40">
        <div className="container-brox max-w-3xl">
          <Reveal>
            <p className="eyebrow mb-5">SUPPORT CLIENȚI</p>
            <SectionHeading title={<>RECLAMAȚII ȘI<br /><span className="text-copper">SOLUȚIONAREA SESIZĂRILOR</span></>} />
            <p className="mt-6 max-w-2xl text-base leading-relaxed text-muted-foreground sm:text-lg">
              Ne poți transmite orice reclamație sau sesizare legată de un proiect, un serviciu sau o
              colaborare. Tratăm fiecare mesaj personal și căutăm împreună cea mai bună soluție.
            </p>
          </Reveal>

          <Reveal delay={0.1}>
            <div className="mt-10 grid gap-px border border-white/10 bg-white/10 sm:grid-cols-2" data-testid="complaints-contact-card">
              <div className="bg-ink-900 p-6 sm:p-8">
                <span className="flex h-11 w-11 items-center justify-center border border-copper/40 text-copper">
                  <Phone className="h-5 w-5" />
                </span>
                <p className="label-brox mt-4 !mb-1">TELEFON / WHATSAPP</p>
                {config.phone ? (
                  <a href={`tel:${config.phone.replace(/\s/g, "")}`} className="text-base text-paper transition-colors hover:text-copper" data-testid="complaints-phone">
                    {config.phone}
                  </a>
                ) : (
                  <p className="text-base text-paper/85">Se actualizează în curând</p>
                )}
              </div>
              <div className="bg-ink-900 p-6 sm:p-8">
                <span className="flex h-11 w-11 items-center justify-center border border-copper/40 text-copper">
                  <Mail className="h-5 w-5" />
                </span>
                <p className="label-brox mt-4 !mb-1">EMAIL</p>
                {config.email ? (
                  <a href={`mailto:${config.email}`} className="text-base text-paper transition-colors hover:text-copper" data-testid="complaints-email">
                    {config.email}
                  </a>
                ) : (
                  <p className="text-base text-paper/85">Se actualizează în curând</p>
                )}
              </div>
            </div>
          </Reveal>

          <Reveal delay={0.14}>
            <div className="mt-10 space-y-8">
              <div>
                <h2 className="font-display text-xl font-bold uppercase tracking-wide text-paper sm:text-2xl" data-testid="complaints-process-title">Cum procedăm</h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                  Preiezi sesizarea telefonic, pe WhatsApp sau pe email, o înregistrăm și te contactăm
                  pentru detalii și clarificări. Analizăm situația, îți comunicăm soluția propusă și
                  confirmăm împreună rezolvarea.
                </p>
              </div>
              <div>
                <h2 className="font-display text-xl font-bold uppercase tracking-wide text-paper sm:text-2xl">Responsabilități contractuale</h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                  Responsabilitățile specifice privind execuția, termenele și garanțiile pentru fiecare
                  proiect sunt cele stabilite în oferta, contractul și documentația aferentă proiectului
                  respectiv.
                </p>
              </div>
              <div>
                <h2 className="font-display text-xl font-bold uppercase tracking-wide text-paper sm:text-2xl" data-testid="complaints-sal-title">Soluționarea alternativă a litigiilor (SAL — ANPC)</h2>
                <p className="mt-3 text-sm leading-relaxed text-muted-foreground sm:text-base">
                  În conformitate cu legislația română privind protecția consumatorilor, poți apela la
                  Soluționarea Alternativă a Litigiilor (SAL) din cadrul Autorității Naționale pentru Protecția
                  Consumatorilor, folosind platforma electronică oficială de mai jos.
                </p>
                <a
                  href={ANPC_SAL_URL}
                  target="_blank"
                  rel="nofollow noopener noreferrer"
                  className="mt-6 inline-block"
                  data-testid="complaints-anpc-link"
                >
                  <img src="/anpc-sal.svg" alt="Soluționarea Alternativă a Litigiilor — ANPC" width="250" height="62" loading="lazy" className="h-auto w-[250px] max-w-full" />
                </a>
                <div className="mt-4">
                  <a
                    href={ANPC_SAL_DIRECT_URL}
                    target="_blank"
                    rel="noopener noreferrer"
                    className="inline-flex min-h-[48px] items-center gap-2 border border-white/15 bg-ink-900 px-5 font-display text-sm font-bold uppercase tracking-wider text-paper transition-all duration-300 hover:border-copper hover:text-copper"
                    data-testid="complaints-anpc-direct-link"
                  >
                    <ShieldCheck className="h-5 w-5 text-copper" />
                    DEPUNE CERERE SAL
                  </a>
                </div>
              </div>
            </div>
          </Reveal>
        </div>
      </section>
    </>
  );
}
